/* DOMNO. rewards — the Leave a review screen (9 Sep 2026)

   Builds a real reviews panel inside the account drawer: every item the customer has received,
   each with its photo, and a button opening Loox's own review form for THAT product.

   🔴 14 SEP 2026 — REVIEWS NO LONGER EARN A FREE PIECE AND THIS SCREEN NO LONGER SAYS THEY DO.
   Charlie, relaying Dom: review earning comes out of the portal entirely and gets set up
   separately. Loox's own £10 stays and is Loox-side — DELIBERATELY NOT QUOTED HERE, because this
   screen cannot see what Loox is actually offering today and a number that drifts out of date is
   worse than no number. If the £10 is confirmed live and stable, say it; do not guess it.
   The Trustpilot version was dropped outright: their guidelines forbid any benefit in exchange
   for a review, and enforcement runs to a Consumer Warning and the TrustScore being hidden.

   ⚠ THE REWARD WORDING WAS WRONG UNTIL 10 SEP 2026 TOO. This screen promised "£10 off your next
   order" for a photo review. That deal was replaced by the free-piece scheme — one per account,
   ever, photo reviews only, real products only — and the £10 had not existed for some time. It
   was a live false promise on a customer-facing screen — the second one this screen has carried,
   which is the reason both notes are kept: a reward line here goes stale the moment the scheme
   moves, and nobody comes back to check. It now promises nothing at all.

   WHY A MODULE, NOT AN EDIT TO THE DRAWER SNIPPET
   snippets/domno-portal-drawer.liquid is 30KB of Charlie's work, and no signed-in screen can be
   tested from this end (Claude cannot sign in as a customer). Injecting keeps his file untouched.

   THE LOOX LINK — the one rule that matters
       /products/<handle>?ref=review
   Loox opens its review form over the product page when it sees ?ref=review, and IGNORES the
   parameter if anything sits between the handle and it. So it is built from the bare handle out
   of window.DP_ORDERS, never from a product URL that might already carry ?variant=.
   https://help.loox.io/article/15-how-do-i-send-my-customers-a-link-to-review-a-product

   THE NAVIGATION TRAP THIS FILE WORKS AROUND
   domno-portal.js keeps a private SECTIONS list ['home','orders','rewards','referral','returns']
   and its show() only ever toggles panels named in it. Calling dpGo('reviews') would therefore
   hide EVERY panel and show nothing — a blank drawer, no error. SECTIONS is a closure variable so
   it cannot be appended to from out here. dpGo is wrapped instead: 'reviews' is handled locally,
   anything else is cleaned up and handed back to the original.

   NO "REVIEWED" TICK YET, deliberately.
   Loox does not tell the storefront what has been reviewed. It CAN tell Shopify, via the Loox
   "New review" trigger in Shopify Flow (carries email, order id, product id, rating, photo URL).
   Once that Flow writes a customer tag or a row to the worker, this file can read it and mark
   items done. Until then every item keeps its button, rather than inventing a state we cannot
   verify.

   "Received" means Shopify says FULFILLED. Liquid has no true delivered flag, so a parcel still
   in transit counts as reviewable. (The ORDER screen can now say delivered, because the returns
   worker reads it off the fulfilment — but this panel has no worker call, so it stays on
   fulfilled.)
*/
(function(){
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function reviewable(){
    var orders = window.DP_ORDERS || [], out = [], seen = {};
    for (var o = 0; o < orders.length; o++){
      var ord = orders[o];
      if (!ord || ord.status !== 'fulfilled') continue;
      var items = ord.items || [];
      for (var i = 0; i < items.length; i++){
        var it = items[i];
        if (!it || !it.handle) continue;
        if (seen[it.handle]) continue;
        seen[it.handle] = true;
        out.push({ title: it.title, variant: it.variant, img: it.img, handle: it.handle, order: ord.name });
      }
    }
    return out;
  }

  function render(panel){
    var list = reviewable();

    if (!list.length){
      panel.innerHTML =
        '<h3 class="sec">Leave a review</h3>' +
        '<div class="c" style="text-align:center;padding:34px 16px;line-height:1.8">' +
          '<div style="font-family:var(--disp);font-weight:900;font-style:italic;font-size:17px;color:var(--ink);margin-bottom:8px">Nothing to review yet</div>' +
          'Once an order lands, everything in it shows up here.' +
        '</div>';
      return;
    }

    var h = '<h3 class="sec">Leave a review</h3>' +
      '<div class="c" style="margin:0 2px 14px;line-height:1.6">Tell us how they\'re wearing. ' +
      'Photos are the ones people actually read, so they genuinely help.</div>';

    for (var i = 0; i < list.length; i++){
      var r = list[i];
      var url = '/products/' + encodeURIComponent(r.handle) + '?ref=review';
      h += '<div class="rw" style="align-items:flex-start;gap:11px">' +
             '<div style="width:58px;height:72px;flex:0 0 58px;background:#f5f5f5;overflow:hidden">' +
               (r.img ? '<img src="' + esc(r.img) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block" loading="lazy">' : '') +
             '</div>' +
             '<div style="flex:1;min-width:0">' +
               '<div class="n" style="font-size:13px">' + esc(r.title) + '</div>' +
               '<div class="c">' + esc([r.variant, r.order].filter(Boolean).join(' · ')) + '</div>' +
               '<a class="btn" style="width:auto;padding:8px 12px;margin-top:9px" href="' + url + '">Review this</a>' +
             '</div>' +
           '</div>';
    }
    panel.innerHTML = h;
  }

  function hideOurs(){
    var p = document.getElementById('p-reviews'); if (p) p.classList.remove('on');
    var m = document.getElementById('m-reviews'); if (m) m.classList.remove('on');
  }

  function showOurs(){
    var panels = document.querySelectorAll('#domno-portal .panel');
    for (var i = 0; i < panels.length; i++) panels[i].classList.remove('on');
    var items = document.querySelectorAll('#dp-menu a');
    for (var j = 0; j < items.length; j++) items[j].classList.remove('on');
    var p = document.getElementById('p-reviews'); if (p) p.classList.add('on');
    var m = document.getElementById('m-reviews'); if (m) m.classList.add('on');
    var menu = document.getElementById('dp-menu'); if (menu) menu.classList.remove('on');
    try{ window.scrollTo(0, 0); }catch(e){}
  }

  function install(){
    var body = document.querySelector('#domno-portal .body');
    var menu = document.getElementById('dp-menu');
    if (!body || !menu || typeof window.dpGo !== 'function') return false;
    if (document.getElementById('p-reviews')) return true;

    var panel = document.createElement('div');
    panel.id = 'p-reviews';
    panel.className = 'panel';
    body.appendChild(panel);
    render(panel);

    var a = document.createElement('a');
    a.id = 'm-reviews';
    a.textContent = 'Reviews';
    a.addEventListener('click', function(){ window.dpGo('reviews'); });
    var rewards = document.getElementById('m-rewards');
    if (rewards && rewards.parentNode) rewards.parentNode.insertBefore(a, rewards.nextSibling);
    else menu.appendChild(a);

    /* see THE NAVIGATION TRAP above */
    var origGo = window.dpGo;
    window.dpGo = function(id){
      if (id === 'reviews'){ showOurs(); return; }
      hideOurs();
      try{ return origGo.apply(this, arguments); }catch(e){}
    };

    /* the Review button on the rewards screen was inert — point it here */
    try{
      var rows = document.querySelectorAll('#p-rewards .rw');
      for (var i = 0; i < rows.length; i++){
        if (/leave a review/i.test(rows[i].textContent || '')){
          var btn = rows[i].querySelector('button.btn');
          if (btn) btn.addEventListener('click', function(){ window.dpGo('reviews'); });
        }
      }
    }catch(e){}

    return true;
  }

  if (!install()){
    var n = 0, iv = setInterval(function(){
      n++;
      if (install() || n > 60) clearInterval(iv);
    }, 100);
  }
})();